/**
 * Types of AD Quartiles.
 */
export enum MKAdQuartile {
    /**
     * FirstQuartile.
     */
    FirstQuartile = "firstquartile",

    /**
     * Midpoint.
     */
    Midpoint = "midpoint",

    /**
     * ThirdQuartile.
     */
    ThirdQuartile = "thirdquartile"
}